<script>
import { ref, computed, onMounted, onUpdated } from 'vue';
import feather from 'feather-icons';
import { useLanguage } from '@/composables/useLanguage';

export default {
  name: 'Home',
  setup() {
    const theme = ref(localStorage.getItem('theme') || 'light');
    const { currentLanguage } = useLanguage();

    const resumeHref = computed(() => {
      return currentLanguage.value === 'id'
        ? '/files/Resume-IqbalAR-ID.pdf'
        : '/files/Resume-IqbalAR-EN.pdf';
    });

    onMounted(() => {
      feather.replace();
      theme.value = localStorage.getItem('theme') || 'light';
    });

    onUpdated(() => {
      feather.replace();
    });

    return {
      theme,
      resumeHref,
    };
  },
};
</script>

<template>
  <section class="relative flex flex-col justify-center items-center mt-12 sm:mt-10 min-h-screen sm:h-96 rounded-lg overflow-hidden">
    <!-- Background illustration -->
    <div class="absolute inset-0 z-0 opacity-30 sm:opacity-50">
      <img
        v-if="theme === 'light'"
        src="@/assets/images/developer.svg"
        alt="Developer"
        class="w-full h-full object-cover"
      >
      <img
        v-else
        src="@/assets/images/developer-dark.svg"
        alt="Developer"
        class="w-full h-full object-cover"
      >
    </div>

    <!-- Banner center contents -->
    <div class="relative z-10 w-full text-center px-4 sm:px-8">
      <div class="flex justify-center mb-6">
        <img
          src="@/assets/images/casualprofile.png"
          class="w-64 h-64 sm:w-72 sm:h-72 rounded-full object-cover border-2 border-white shadow-lg dark:border-gray-800"
        >
      </div>
      <h1
        class="font-general-semibold text-3xl md:text-5xl xl:text-6xl text-ternary-dark dark:text-primary-light"
      >
        Iqbal Abdul Rauf
      </h1>
      <p
        class="font-general-medium mt-4 text-lg sm:text-2xl xl:text-3xl leading-none text-gray-600 dark:text-gray-300"
      >
        Software Quality Assurance and Content Writer
      </p>
      <div class="flex flex-wrap justify-center gap-4 mt-12">
        <router-link
          to="/about"
          class="flex justify-center items-center px-6 sm:px-8 py-2.5 sm:py-3 text-lg border border-indigo-200 dark:border-ternary-dark shadow-lg rounded-lg bg-white dark:bg-gray-800 hover:bg-indigo-500 dark:hover:bg-indigo-700 text-gray-700 hover:text-white dark:text-gray-200 transition-all duration-500"
          aria-label="About Me"
        >
          <span class="text-sm sm:text-lg font-general-medium">Tentang Saya</span>
        </router-link>

        <a
          download="Resume-IqbalARauf.pdf"
          :href="resumeHref"
          class="flex justify-center items-center px-6 sm:px-8 py-2.5 sm:py-3 text-lg border border-indigo-200 dark:border-ternary-dark shadow-lg rounded-lg bg-indigo-50 dark:bg-indigo-900 focus:ring-1 focus:ring-indigo-900 hover:bg-indigo-500 dark:hover:bg-indigo-700 text-gray-500 hover:text-white dark:text-gray-300 dark:hover:text-white transition-all duration-500"
          aria-label="Download Resume"
        >
          <i
            data-feather="arrow-down-circle"
            class="mr-2 sm:mr-3 w-5 sm:w-6 transition-transform duration-100"
          />
          <span class="text-sm sm:text-lg font-general-medium">Download Resume</span>
        </a>
      </div>
    </div>
  </section>
</template>

<style scoped></style>
